<template>
<div class="i-paginator-wrapper number">
  <nav class="nav">
  <ul v-show="totalPages>1" :class="`list iPaginator__pagination`">
    <li v-if="opts.edgeNavigation && totalChunks > 1" :class="`i-paginator page-item ${page===1?'disabled':''} i-paginator-prev-chunk`" @click="setPage(1)">
      <a class="page-link" href="javascript:void(0);" disabled="page===1">{{opts.texts.first}}</a>
    </li>
    <li  v-if="opts.chunksNavigation==='fixed'" :class="`i-paginator page-item prev i-paginator-prev-chunk ${allowedChunkClass(-1)}`" @click="setChunk(-1)">
      <a class="page-link" href="javascript:void(0);" disabled="!!allowedChunkClass(-1)"><span class="fa fa-chevron-double-left"></span></a>
    </li>
    <li :class="`i-paginator page-item prev i-paginator-prev-page ${allowedPageClass(page-1)}`" @click="prev()">
      <a class="page-link" href="javascript:void(0);" disabled="!!allowedPageClass(page-1)"><span class="fa fa-chevron-left"></span></a>
    </li>
    <li v-for="page in pages" :class="`i-paginator page-item ${activeClass(page)}`" @click="setPage(page)">
      <a class="page-link+' '+activeClass(page)" href="javascript:void(0)"role="button">{{page}}</a>
    </li>
    <li :class="`i-paginator page-item next i-paginator-next-page ${allowedPageClass(page+1)}`" @click="next()">
      <a class="page-link" href="javascript:void(0);" disabled="!!allowedPageClass(page+1)"><span class="fa fa-chevron-right"></span></a>
    </li>
    <li v-if="opts.chunksNavigation==='fixed'" :class="`i-paginator page-item next i-paginator-next-chunk ${allowedChunkClass(1)}`" @click="setChunk(1)">
      <a class="page-link" href="javascript:void(0);" disabled="!!allowedChunkClass(1)"><span class="fa fa-chevron-double-right"></span></a>
    </li>
    <li  v-if="opts.edgeNavigation && totalChunks > 1" :class="`i-paginator page-item ${page===totalPages?'disabled':''} i-paginator-prev-chunk`" @click="setPage(totalPages)">
      <a class="page-link" href="javascript:void(0);" disabled="page===totalPages">{{opts.texts.last}}</a>
    </li>
  </ul>
  <!-- <p v-show="parseInt(records)"
  class="iPaginator__count count">{{count}}</p> -->
</nav>
</div>
</template>
<script>
let bus = require('./bus');

import Vue from 'vue';

function range(start, count) {
  return Array.apply(0, Array(count))
  .map(function (element, index) {
  return index + start;
  });
}

export default {
  name: 'i-paginator',
  props: {
    for: {
      type: String,
      required: false
    },
    page: {
      type: Number,
      required: true
    },
    records: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 25
    },
    vuex: {
      type: Boolean
    },
    options: {
      type: Object
    }
  },
  created: function() {

    if (!this.vuex) return;

    if (!this.for) {
      throw new Error('i-paginator: The "for" prop is required when using vuex');
    }

    let name = this.for;

    if (this.$store.state[name]) return;

    this.$store.registerModule(this.for, {
      state: {
        page: 1
      },
      mutations: {
        [`${name}/PAGINATE`](state, page) {
          state.page = page
        }
      }
    })
  },
  data: function() {
    return {
      Page: 1,
      firstPage: 1,
    }
  },
  computed: {
    opts() {
      let defaultOptions = {
        format: true,
        chunk: 4,
        chunksNavigation: 'fixed',
        edgeNavigation: false,
        texts: {
          count: '{from} - {to} / {count} |{count}| 1 / 1',
          first: 'First',
          last: 'Last'
        }
      };
      return Object.assign({},defaultOptions, this.options);
    },
   /* page() {
      return this.vuex ? this.$store.state[this.for].page : this.Page;
    },*/
    pages: function() {
      if (!this.records)
        return [];

      return range(this.paginationStart, this.pagesInCurrentChunk);
    },
    totalPages: function() {
      return this.records ? Math.ceil(this.records / this.perPage) : 1;
    },
    totalChunks: function() {
      return Math.ceil(this.totalPages / this.opts.chunk);
    },
    currentChunk: function() {
      return Math.ceil(this.page / this.opts.chunk);
    },
    paginationStart: function() {

      if (this.opts.chunksNavigation === 'scroll') {
        return this.firstPage;
      }

      return ((this.currentChunk - 1) * this.opts.chunk) + 1;
    },
    pagesInCurrentChunk: function() {
      return this.paginationStart + this.opts.chunk <= this.totalPages ?
        this.opts.chunk :
        this.totalPages - this.paginationStart + 1;

    },
    count: function() {
      if (/{page}/.test(this.opts.texts.count)) {
        if (this.totalPages <= 1) return '';
        return this.opts.texts.count.replace('{page}', this.page).replace('{pages}', this.totalPages);
      }

      let parts = this.opts.texts.count.split('|');
      let from = ((this.page - 1) * this.perPage) + 1;
      let to = this.page == (this.totalPages) ? this.records : from + this.perPage - 1;
      let i = Math.min(this.records == 1 ? 2 : this.totalPages == 1 ? 1 : 0, parts.length - 1);

      return parts[i].replace('{count}', this.formatNumber(this.records))
        .replace('{from}', this.formatNumber(from))
        .replace('{to}', this.formatNumber(to))
    }
  },
  methods: {
    setPage: function(page) {
      if (this.allowedPage(page)) {
        this.paginate(page);
      }
    },
    paginate(page) {
      if (this.vuex) {
        this.$store.commit(`${this.for}/PAGINATE`, page);
      } else {
        this.Page = page;
      }

      this.$emit('input', page);

      if (this.for) {
        console.log('vue-pagination::' + this.for, page);
      }
    },
    next: function() {
      var page = this.page + 1;
      if (this.opts.chunksNavigation === 'scroll' && this.allowedPage(page) && !this.inDisplay(page)) {
        this.firstPage++;
      }
      return this.setPage(page);
    },
    prev: function() {
      var page = this.page - 1;

      if (this.opts.chunksNavigation === 'scroll' && this.allowedPage(page) && !this.inDisplay(page)) {
        this.firstPage--;
      }

      return this.setPage(page);
    },
    inDisplay(page) {

      var start = this.firstPage;
      var end = start + this.opts.chunk - 1;

      return page >= start && page <= end;
    },
    nextChunk: function() {
      return this.setChunk(1);
    },
    prevChunk: function() {
      return this.setChunk(-1);
    },
    setChunk: function(direction) {
      this.setPage((((this.currentChunk - 1) + direction) * this.opts.chunk) + 1);
    },
    allowedPage: function(page) {
      return page >= 1 && page <= this.totalPages;
    },
    allowedChunk: function(direction) {
      return (direction == 1 && this.currentChunk < this.totalChunks) ||
        (direction == -1 && this.currentChunk > 1);
    },
    allowedPageClass: function(direction) {
      return this.allowedPage(direction) ? '' : 'disabled';
    },
    allowedChunkClass: function(direction) {
      return this.allowedChunk(direction) ? '' : 'disabled';
    },
    activeClass: function(page) {
      return this.page == page ? 'active' : '';
    },
    formatNumber: function(num) {
      if (!this.opts.format) return num;
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  beforeDestroy() {
    bus.$off();
    bus.$destroy();
  }
}
</script>
<style lang="css" scoped>

ul{
  padding: 0;
}
.i-paginator-wrapper{
  text-align: center;
}
.page-item{
  border:1px solid lightgrey;
  padding:4px 8px;
  background: whitesmoke;
  list-style: none;
  display: inline-block;
  margin:0;
  border-radius: 2px;
  margin:0 1px;
  cursor: pointer;
  color:grey;

}
.page-item a{
  text-decoration: none;
  color:grey;
}
.page-item:hover{
  background: linear-gradient(#ffffff,#e2e2e2);
    border-color: grey;
}
.page-item:active a,.page-item.active a{
  color: white;
}
.page-item.active,.page-item:active{
    background: linear-gradient(#3079c5,#1c4876);
    border-color: #051a2e;
    
}


</style>

